import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PriceConvert } from '../../../../../UI/Price/Price';
import Slider from 'react-slick';

import * as pkg from 'react-lazy-load-image-component';
const { LazyLoadImage } = pkg;

export class ProductCollection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  populateCurrentCollection() {
    let selectMainImg = this.props.passedFunctions.parentState.selectedMainImg;

    //All Images - then get just color
    const allImagesArr = Object.values(this.props.passedFunctions.allImages ?? {});
    const allColorArr = Array.isArray(allImagesArr) ? allImagesArr.filter((img) => img.attrType === 'Color') : [];

    //Get Color Match
    const currentColor = allColorArr.find((color) => color?.imgName?.toString() === selectMainImg)?.attrValue || '';

    //get collection with that color
    var returnCollection = {};
    if (this.state.collections) {
      for (var i = 0; i < this.state.collections.length; i++) {
        var thisCollection = this.state.collections[i];
        if (thisCollection.color == currentColor || thisCollection.color == 'groupTag') {
          returnCollection = thisCollection;
        }
      }
    }
    return returnCollection;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.contentData.productId != nextProps.contentData.productId) {
      this.fetchCollection(nextProps.contentData.productId, nextProps.contentData.dept, nextProps.contentData.mic);
    }
  }

  render() {
    var currentCollection = this.state.collections && this.populateCurrentCollection();
    this.props.passedFunctions.setCurrentCollection(
      currentCollection && currentCollection.details ? currentCollection.details : []
    );
    let slidesToShow = this.props.slidesToShow || 6;
    if (this.props.passedAppFunctions.siteFormat == 'tablet') {
      let slidesToShow = 4;
      slidesToShow += 0.5;
    }

    var settings = {
      onReInit: function () {
        try {
          zonos.displayCurrency();
        } catch (e) {}
      },
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      swipe: true,
      lazyLoad: true,
      arrows:
        this.state.collections &&
        currentCollection &&
        currentCollection.details &&
        currentCollection.details.length > this.props.slidesToShow,
      responsive: this.props.passedAppFunctions
        ? this.props.passedAppFunctions.siteFormat == 'tablet'
          ? [
              {
                breakpoint: 1367,
                settings: {
                  arrows: false,
                  vertical: false,
                  slidesToShow: 4.5,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 4.5,
                  slidesToScroll: 3,
                  vertical: false,
                  arrows: false,
                },
              },
            ]
          : ''
        : '',
    };

    slidesToShow = 2.5;

    var mobileSettings = {
      onReInit: function () {
        try {
          zonos.displayCurrency();
        } catch (e) {}
      },
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      swipe: true,
      lazyLoad: true,
      arrows: false,
    };
    return (
      <div
        className={`collection-area m-t-40 ${settings.arrows ? 'has-arrows' : ''} ${this.props.passedAppFunctions.siteFormat != 'mobile' ? 'col-sm-12' : ''}`}
      >
        {this.state.collections &&
        currentCollection &&
        currentCollection.details &&
        currentCollection.details.length > 0 &&
        this.props.passedAppFunctions.siteFormat != 'mobile' ? (
          <div>
            <h2 className='relative'>
              <span className='shop-the-collection-title'>Other Styles In This Group</span>
            </h2>
            <Slider {...settings}>
              {currentCollection.details.map((currentCollectionMember, index) => (
                <figure
                  className='item'
                  key={`${currentCollectionMember.catentryId}${currentCollectionMember.imageName}${index}`}
                >
                  <Link
                    to={{
                      pathname: `/p/${currentCollectionMember.keyword}/${currentCollectionMember.catentryId}`,
                      state: {
                        qv: true,
                        extraQVProps: { collection: currentCollection, thisCollectionMember: currentCollectionMember },
                      },
                    }}
                    aria-label={'Link to ' + currentCollectionMember.name}
                  >
                    <LazyLoadImage
                      src={`//dimg.dillards.com/is/image/DillardsZoom/nav/${currentCollectionMember.keyword}/${currentCollectionMember.imageName}.jpg`}
                      alt={currentCollectionMember.name}
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: `/p/${currentCollectionMember.keyword}/${currentCollectionMember.catentryId}`,
                      state: {
                        qv: true,
                        extraQVProps: { collection: currentCollection, thisCollectionMember: currentCollectionMember },
                      },
                    }}
                    aria-label={'Link to ' + currentCollectionMember.name}
                  >
                    <p className='item-title'>
                      {currentCollectionMember.brandName.split('#double;').join('"').split('&quot;').join('"')}
                      {currentCollectionMember.onSpecial !== undefined &&
                      currentCollectionMember.offerPriceMin !== undefined &&
                      currentCollectionMember.offerPriceMax !== undefined ? (
                        <React.Fragment>
                          {currentCollectionMember.onSpecial == 'false' ? (
                            <React.Fragment>
                              <br />
                              <PriceConvert
                                priceOne={currentCollectionMember.offerPriceMin}
                                priceTwo={currentCollectionMember.offerPriceMax}
                              />
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <span className='now-price'>
                                Now{' '}
                                <PriceConvert
                                  priceOne={currentCollectionMember.offerPriceMin}
                                  priceTwo={currentCollectionMember.offerPriceMax}
                                />
                              </span>
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment></React.Fragment>
                      )}
                    </p>
                  </Link>
                </figure>
              ))}
            </Slider>
          </div>
        ) : //For Mobile
        this.state.collections &&
          currentCollection &&
          currentCollection.details &&
          currentCollection.details.length > 0 &&
          this.props.passedAppFunctions.siteFormat == 'mobile' ? (
          <div>
            <h6 className='relative'>
              <span className='shop-the-collection-title'>Other Styles In This Group</span>
            </h6>
            <Slider {...mobileSettings}>
              {currentCollection.details.map((currentCollectionMember, index) => (
                <figure
                  className='item'
                  key={`${currentCollectionMember.catentryId}${currentCollectionMember.imageName}${index}`}
                >
                  <Link
                    to={{
                      pathname: `/p/${currentCollectionMember.keyword}/${currentCollectionMember.catentryId}`,
                      state: {
                        qv: true,
                        extraQVProps: { collection: currentCollection, thisCollectionMember: currentCollectionMember },
                      },
                    }}
                    aria-label={'Link to ' + currentCollectionMember.name}
                  >
                    <LazyLoadImage
                      src={`//dimg.dillards.com/is/image/DillardsZoom/nav/${currentCollectionMember.keyword}/${currentCollectionMember.imageName}.jpg`}
                      alt={currentCollectionMember.name}
                    />
                  </Link>
                  <Link
                    to={{
                      pathname: `/p/${currentCollectionMember.keyword}/${currentCollectionMember.catentryId}`,
                      state: {
                        qv: true,
                        extraQVProps: { collection: currentCollection, thisCollectionMember: currentCollectionMember },
                      },
                    }}
                    aria-label={'Link to ' + currentCollectionMember.name}
                  >
                    <p className='item-title'>
                      {currentCollectionMember.brandName.split('#double;').join('"').split('&quot;').join('"')}
                      {currentCollectionMember.onSpecial !== undefined &&
                      currentCollectionMember.offerPriceMin !== undefined &&
                      currentCollectionMember.offerPriceMax !== undefined ? (
                        <React.Fragment>
                          {currentCollectionMember.onSpecial == 'false' ? (
                            <React.Fragment>
                              <br />
                              <PriceConvert
                                priceOne={currentCollectionMember.offerPriceMin}
                                priceTwo={currentCollectionMember.offerPriceMax}
                              />
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <br />
                              <span className='now-price'>
                                Now{' '}
                                <PriceConvert
                                  priceOne={currentCollectionMember.offerPriceMin}
                                  priceTwo={currentCollectionMember.offerPriceMax}
                                />
                              </span>
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment></React.Fragment>
                      )}
                    </p>
                  </Link>
                </figure>
              ))}
            </Slider>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  componentDidMount() {
    this.fetchCollection();
  }

  fetchCollection(nextProductId, nextDept, nextMic) {
    if (this.props.passedAppFunctions.wasParms.displayCollections == 'true') {
      var axiosOptions = {
        method: 'get',
        url: `/data/collections?catentryId=${nextProductId || this.props.contentData.productId}&dept=${nextDept || this.props.contentData.dept}&mic=${
          nextMic || this.props.contentData.mic
        }`,
      };
      axios(axiosOptions).then((ajaxResponse) => {
        var cmdRespIsJSON;
        var responseJSON = {};
        try {
          responseJSON =
            typeof ajaxResponse.data == 'object'
              ? ajaxResponse.data.contentData
              : JSON.parse(ajaxResponse.data.contentData);
          cmdRespIsJSON = true;
        } catch (e) {}
        if (cmdRespIsJSON) {
          //update state with the new information
          this.setState({ collections: responseJSON });
        } else {
        }
      });
    }
  }
}

export default ProductCollection;
